<template>
    <div class="device-not-allowed">
        <h5 class="not-text">Este sitio debe visualizarse en un navegador web de escritorio</h5>
        <img src="@/assets/no-results.svg" alt="Device not allowed" class="not-img">
        <img src="@/assets/icons/notros-footer.svg" alt="Footer logo" class="not-footer">
    </div>
</template>

<script>
export default {
    name: 'DeviceNotAllowed'
}
</script>

<style lang="sass">
.device-not-allowed
    width: 100%
    height: 100%
    display: none
    position: fixed
    top: 0
    left: 0
    z-index: 9999
    background-image: linear-gradient(155deg, #2a0681, #15032b)
    @media (max-width: $tablet)
        display: block
.device-not-allowed .not-text
    width: calc(100% - 16px)
    max-width: 343px
    height: 84px
    font-family: Montserrat
    font-size: 23px
    font-weight: 600
    color: #ffffff
    margin: 38px auto
.device-not-allowed .not-img
    max-width: 95%
    max-height: 95%
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
.device-not-allowed .not-footer
    position: absolute
    bottom: 46px
    left: 50%
    transform: translateX(-50%)
</style>